<template>
  <div>
    <iframe v-if="hash" style="width: 100%; height: 500px"
            :src="`https://map.assistance10.com/address?&h=${hash}&o=${orderId ?? 0}&c=${cityId}&a=${address}`"
            frameborder="0"></iframe>
  </div>
</template>

<script>

import moment from "moment";
import CryptoJS from "crypto-js";
import api from "@/api";

export default {
  props: ['orderId', 'address', 'cityId'],
  data() {
    return {
      hash: null,
    }
  },
  mounted() {
    this.hash = this.generateKey();
    // this.updateOrderGeo(this.orderId)
  },
  methods: {
    generateKey() {
      return CryptoJS.AES.encrypt(JSON.stringify({
        id: this.$currentUID, time: moment().format('YYYY-MM-DD HH:mm')
      }), 'secretMapOrders').toString();
    },
    async updateOrderGeo(orderId) {
      const {data} = await api.post('/new/orders/updateByAction', {
        action: 'updateGeoData',
        order_id: orderId,
      })
    },
  }
}

</script>
